const carouselItems = [
  {
    title: '热门影视专题',
    desc: '精选近期最受关注的热门电影与电视剧集，涵盖动作、悬疑、喜剧等多种类型，发现你的下一部心头好。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20film%20reels%20and%20dramatic%20lighting%20warm%20coral%20tones%20dark%20theater%20atmosphere%20golden%20accents%20elegant%20composition%20professional%20photography%20style%20high%20detail%20soft%20shadows&width=600&height=400&seq=carousel-01-69&orientation=landscape',
    tag: '影视',
  },
  {
    title: '综艺娱乐精选',
    desc: '汇集当下最火爆的综艺节目资源，搞笑、真人秀、脱口秀一网打尽，轻松一刻从69视频开始。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20with%20colorful%20stage%20lights%20and%20dynamic%20atmosphere%20warm%20golden%20spotlights%20entertainment%20venue%20setting%20professional%20lighting%20setup%20modern%20broadcast%20studio%20feel%20high%20detail%20harmonious%20composition&width=600&height=400&seq=carousel-02-69&orientation=landscape',
    tag: '综艺',
  },
  {
    title: '动漫番剧专区',
    desc: '热门动漫番剧持续更新，从经典到新番，日漫国漫全覆盖，二次元爱好者不可错过的宝藏专题。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20art%20collection%20with%20vibrant%20character%20illustrations%20in%20dynamic%20poses%20warm%20color%20palette%20with%20coral%20and%20gold%20highlights%20clean%20modern%20design%20aesthetic%20cinematic%20composition%20high%20detail%20professional%20illustration&width=600&height=400&seq=carousel-03-69&orientation=landscape',
    tag: '动漫',
  },
  {
    title: '纪录片频道',
    desc: '自然、人文、历史、科技各类优质纪录片，拓展视野增长见识，在影像中探索世界的无限可能。',
    img: 'https://readdy.ai/api/search-image?query=Majestic%20nature%20documentary%20scene%20with%20mountain%20landscapes%20and%20wildlife%20silhouettes%20warm%20golden%20hour%20lighting%20cinematic%20wide%20shot%20atmospheric%20composition%20professional%20photography%20style%20rich%20earthy%20tones%20high%20detail%20harmonious&width=600&height=400&seq=carousel-04-69&orientation=landscape',
    tag: '纪录',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10">
            焦点专题
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {carouselItems.map((item, i) => (
              <article
                key={i}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="relative aspect-[3/2] overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-medium bg-primary-500 text-white whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}